import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UIMedia from 'UIComponents/layout/UIMedia';
import UIMediaLeft from 'UIComponents/layout/UIMediaLeft';
import UIMediaBody from 'UIComponents/layout/UIMediaBody';

/**
 * Component used for displaying the options in a UISelect whose options use a
 * network icon. Intended to be set as a UISelect's `optionComponent` prop.
 */
const NetworkSelectOption = (_ref) => {
  let {
    className,
    option: {
      networkIcon,
      text
    }
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "option"]);

  return /*#__PURE__*/_jsx("div", Object.assign({
    className: `p-left-5 p-right-2 p-y-2 ${className}`
  }, props, {
    children: /*#__PURE__*/_jsxs(UIMedia, {
      align: "center",
      className: "m-y-1 m-left-2",
      children: [/*#__PURE__*/_jsx(UIMediaLeft, {
        children: networkIcon
      }), /*#__PURE__*/_jsx(UIMediaBody, {
        className: "m-left-2",
        children: text
      })]
    })
  }));
};

export default NetworkSelectOption;